import React, {
  useCallback,
  useContext,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useForm } from 'react-hook-form';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  FormControlLabel,
  Grid,
  LinearProgress,
  Radio,
  Tooltip,
  Typography,
} from '@mui/material';
import {
  Delete,
  Edit,
  ExpandMore,
  Link,
  Visibility,
} from '@mui/icons-material';
import {
  DataGrid,
  GridColumnMenuContainer,
  GridActionsCellItem,
  GridFilterMenuItem,
} from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import { toastWarning } from 'utils/toast';
import { dropTipoRateio } from 'utils/drops';
import {
  checkInfosProduto,
  CustomPagination,
  summarizer,
  encryptURL,
  round,
  findOnArray,
} from 'utils/functions';
import { DocumentosContext } from 'contexts/DocumentosContext';
import { useDialog, useModal, useDrawer } from 'components/Modals';
import HistoricoCompraModal from 'components/Modals/HistoricoCompraModal';
import CatalogoModal from 'components/Modals/CatalogoModal';
import ProdutoModal from 'components/Modals/ProdutoModal';
import Card from 'components/Card';
import Input from 'components/Input';
import Button from 'components/Button';
import Dropdown from 'components/Dropdown';
import InputMask from 'components/InputMask';
import ButtonMenu from 'components/ButtonMenu';
import VirtualDrop from 'components/VirtualDrop';
import localeText from 'utils/localeText';
import Blank from 'assets/blank.png';
import styles from '../styles';

const DataGridColumnMenu = (props) => (
  <GridColumnMenuContainer {...props}>
    <GridFilterMenuItem
      column={props.currentColumn}
      onClick={props.hideMenu}
    />
  </GridColumnMenuContainer>
);

const Itens = ({
  drops,
  onSubmit,
  onDelete,
  documento = {},
  disableActions,
  onSubmitImposto,
  onSubmitCfo,
}) => {
  const { openDrawer } = useDrawer();
  const { openDialog } = useDialog();
  const { openModal, closeModal } = useModal();
  const [selected, setSelected] = useState([]);
  const navigate = useNavigate();
  const rotina = 'DocumentoItem';

  const Modal = ({ item }) => {
    const inputRef = useRef(null);
    const [keepOpen, setKeepOpen] = useState(false);
    const [additionals, setAdditionals] = useState(null);
    const [additionalLoading, setAdditionalsLoading] = useState(false);
    const { postLoading, documento } = useContext(DocumentosContext);
    const defaultValues = {
      id: item?.id,
      documento_id: documento?.id,
      produto_id: item?.produto_id || null,
      descricao: item?.descricao || '',
      quantidade: item?.quantidade || '',
      unidade_medida_id: item?.unidade_medida_id || null,
      referencia: item?.referencia || '',
      preco: item?.preco || '',
      desconto1_pc: item?.desconto1_pc || '',
      desconto_vlr: item?.desconto_vlr || '',
      przent: item?.przent || null,
      planoconta_id: item?.planoconta_id || null,
      ccusto_id: item?.ccusto_id || null,
      aplicacao_id: item?.aplicacao_id || null,
      frota_id: item?.frota_id || null,
      infadc: item?.infadc || '',
    };
    const { control, handleSubmit, setValue, watch } = useForm({
      defaultValues,
    });

    const getTotal = () =>
      (watch('quantidade') || 1) * watch('preco') + watch('desconto_vlr');

    const callback = () => {
      setValue('produto_id', null);
      setValue('descricao', '');
      setValue('quantidade', '');
      setValue('unidade_medida_id', null);
      setValue('referencia', '');
      setValue('preco', '');
      setValue('desconto1_pc', '');
      setValue('desconto_vlr', '');
      setValue('przent', null);
      setValue('planoconta_id', null);
      setValue('ccusto_id', null);
      setValue('aplicacao_id', null);
      setValue('frota_id', null);
      setValue('infadc', '');
      const input = inputRef.current?.querySelector('input');
      input?.focus();
    };

    const onConfirm = (values) => {
      const ext_prd = documento?.DocumentoItems?.find(
        (s) => s?.produto_id === values?.produto_id
      );
      if (Boolean(ext_prd) && !Boolean(item?.id)) {
        const result = window.confirm(
          'Atenção! Produto já adicionado. Deseja incluir novamente?'
        );
        if (!result) {
          return;
        }
      }
      if (keepOpen) {
        onSubmit({ Itens: [values] }, callback);
      } else {
        onSubmit({ Itens: [values] });
      }
    };

    useEffect(() => {
      const desconto_vlr =
        watch('desconto1_pc') * watch('preco') * watch('quantidade');
      setValue(
        'desconto_vlr',
        desconto_vlr !== 0 ? desconto_vlr * -0.01 : desconto_vlr
      );
    }, [watch('desconto1_pc'), watch('preco'), watch('quantidade')]);

    const itemOptions = [
      {
        name: 'Histórico de Compras do Fornecedor',
        icon: 'work_history',
        action: () => {
          if (Boolean(documento?.cadastro_id)) {
            openDialog(
              <HistoricoCompraModal
                cadastro_id={documento?.cadastro_id}
                onSubmit={(data) => {
                  if (Boolean(data?.length)) {
                    onSubmit({
                      Itens: data?.map((d) => ({
                        ...d,
                        documento_id: documento?.id,
                      })),
                    });
                  }
                }}
              />,
              'Histórico de Compras do Fornecedor'
            );
          } else {
            toastWarning('Documento não possui entidade');
          }
        },
      },
      {
        name: 'Histórico de Compras do Produto',
        icon: 'work_history',
        action: () => {
          if (Boolean(watch('produto_id'))) {
            openDialog(
              <HistoricoCompraModal
                produto_id={watch('produto_id')}
                onSubmit={(data) => {
                  if (Boolean(data?.length)) {
                    onSubmit({
                      Itens: data?.map((d) => ({
                        ...d,
                        documento_id: documento?.id,
                      })),
                    });
                  }
                }}
              />,
              'Histórico de Compras do Produto'
            );
          } else {
            toastWarning('Selecione um Produto');
          }
        },
      },
      {
        name: 'Catálogo de Produtos',
        icon: 'balance',
        action: () =>
          openDialog(
            <CatalogoModal
              onSubmit={(data) => {
                if (Boolean(data?.length)) {
                  onSubmit({
                    Itens: data?.map((d) => ({
                      produto_id: d?.id,
                      descricao: d?.descricao,
                      quantidade: d?.quantidade || 1,
                      referencia: d?.referencia,
                      unidade_medida_id: d?.unidade_medida_id,
                      preco: d?.custo || 0,
                      documento_id: documento?.id,
                    })),
                  });
                }
                closeModal();
              }}
              cadastro_id={documento?.cadastro_id}
            />,
            'Catálogo de Produtos'
          ),
      },
    ];

    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6" component="div" align="center">
            Informações Gerais
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Grid container spacing={2}>
            {!Boolean(item) &&
              (Boolean(documento?.Especie?.natureza === 'COMPRA') ||
                Boolean(documento?.Especie?.natureza === 'ORCAMENTO')) && (
                <Grid item xs={12} textAlign="center">
                  <ButtonMenu
                    buttonProps={{ variant: 'outlined' }}
                    options={itemOptions}
                  />
                </Grid>
              )}
            <Grid item xs={12}>
              <Box flex={1} ref={inputRef}>
                <VirtualDrop
                  busca_refinada
                  name="produto_id"
                  control={control}
                  label="Produto"
                  options={drops?.Produto}
                  onValueChange={async (p) => {
                    setAdditionals(null);
                    if (
                      p?.value &&
                      !(Boolean(item?.id) && !Boolean(item?.produto_id))
                    ) {
                      try {
                        setAdditionalsLoading(true);
                        const produto = await checkInfosProduto({
                          disponivel: 'SIM',
                          produto_id: p?.value,
                          filial_id: documento?.filial_id,
                          cadastro_id: documento?.cadastro_id,
                        });
                        setValue('descricao', produto?.descricao);
                        setValue('quantidade', 1);
                        setValue(
                          'unidade_medida_id',
                          produto?.unidade_medida_id
                        );
                        setValue('referencia', produto?.referencia);
                        setValue('preco', produto?.custo);
                        setAdditionals({
                          saldo: produto?.saldo,
                          referencia: produto?.referencia,
                          localizador: produto?.localizador,
                          imagem: produto?.imagem,
                        });
                      } catch (error) {
                      } finally {
                        setAdditionalsLoading(false);
                      }
                    }
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Input name="descricao" control={control} label="Descrição" />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Input
                name="quantidade"
                control={control}
                label="Quantidade"
                type="number"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Dropdown
                name="unidade_medida_id"
                control={control}
                label="Unidade de Medida"
                options={drops?.UnidadeMedida}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Input name="referencia" control={control} label="Referência" />
            </Grid>
            <Grid item xs={12} sm={4}>
              <InputMask
                name="desconto1_pc"
                control={control}
                label="% Desconto"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <InputMask
                name="preco"
                control={control}
                label="Preço Unitário"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <InputMask
                name="przent"
                control={control}
                label="Prazo de Entrega"
                type="date"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Dropdown
                name="planoconta_id"
                control={control}
                label="Plano de Conta"
                options={drops?.Planoconta?.filter(
                  (p) => p?.operacional === 'SIM'
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Dropdown
                name="ccusto_id"
                control={control}
                label="Centro de Custo"
                options={drops?.Ccusto}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Dropdown
                name="aplicacao_id"
                control={control}
                label="Aplicação"
                options={drops?.Aplicacao}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Dropdown
                name="frota_id"
                control={control}
                label="Frota"
                options={drops?.Frota}
              />
            </Grid>
            <Grid item xs={12}>
              <Input
                name="infadc"
                control={control}
                label="Informações Adicionais"
                multiline
                rows={2}
              />
            </Grid>
            {!Boolean(item?.id) && (
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Radio
                      checked={keepOpen}
                      onChange={(_, v) => setKeepOpen(v)}
                    />
                  }
                  label="Continuar adicionando após salvar"
                />
              </Grid>
            )}
            <Grid item xs={12}>
              <Typography variant="body1" component="div" align="center">
                Total:{' '}
                {getTotal()?.toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        {Boolean(watch('produto_id')) && Boolean(additionals) && (
          <Grid item xs={12} sm={6}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Box
                  component="img"
                  sx={styles.image}
                  src={additionals?.imagem || Blank}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography variant="body1" component="div" align="center">
                  Saldo: {additionals?.saldo || '0'}{' '}
                  {additionals?.UnidadeMedida?.descricao || ''}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography variant="body1" component="div" align="center">
                  Referência: {additionals?.referencia || '-'}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography variant="body1" component="div" align="center">
                  Localização: {additionals?.localizador || '-'}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        )}
        <Grid item xs={12} textAlign="center">
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit(onConfirm)}
            loading={postLoading || additionalLoading}
          >
            Salvar
          </Button>
        </Grid>
      </Grid>
    );
  };

  const MultiModal = ({ itens = [] }) => {
    const { postLoading } = useContext(DocumentosContext);
    const defaultValues = {
      planoconta_id: null,
      ccusto_id: null,
      aplicacao_id: null,
      frota_id: null,

      cfo_id: null,

      przent: null,
      pedcomp: null,
      comissao_pc: '',
    };
    const { control, handleSubmit } = useForm({ defaultValues });

    const onConfirm = ({
      planoconta_id,
      ccusto_id,
      aplicacao_id,
      frota_id,
      cfo_id,
      przent,
      pedcomp,
      comissao_pc,
    }) => {
      const Itens = itens?.map((i) => ({
        id: i?.id,
        documento_id: i?.documento_id,
        ...(Boolean(planoconta_id) && { planoconta_id }),
        ...(Boolean(ccusto_id) && { ccusto_id }),
        ...(Boolean(aplicacao_id) && { aplicacao_id }),
        ...(Boolean(frota_id) && { frota_id }),
        ...(Boolean(cfo_id) && { cfo_id }),
        ...(Boolean(przent) && { przent }),
        ...(Boolean(pedcomp) && { pedcomp }),
        ...(Boolean(comissao_pc) && { comissao_pc }),
      }));

      onSubmit({ Itens });
    };

    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Typography variant="h6">Produtos Selecionados</Typography>
            </AccordionSummary>
            <AccordionDetails>
              {itens?.map((i) => (
                <Box my={1}>
                  <Typography variant="caption">
                    • {i?.referencia} - {i?.descricao}
                  </Typography>
                </Box>
              ))}
            </AccordionDetails>
          </Accordion>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Dropdown
            name="planoconta_id"
            control={control}
            label="Plano de Conta"
            options={drops?.Planoconta?.filter((p) => p?.operacional === 'SIM')}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Dropdown
            name="ccusto_id"
            control={control}
            label="Centro de Custo"
            options={drops?.Ccusto}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Dropdown
            name="aplicacao_id"
            control={control}
            label="Aplicação"
            options={drops?.Aplicacao}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Dropdown
            name="frota_id"
            control={control}
            label="Frota"
            options={drops?.Frota}
          />
        </Grid>
        <Grid item xs={12}>
          <Dropdown
            name="cfo_id"
            control={control}
            label="CFOP"
            options={drops?.Cfo}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <InputMask
            name="przent"
            control={control}
            label="Prazo de Entrega"
            type="date"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Input name="pedcomp" control={control} label="Pedido de Compra" />
        </Grid>
        <Grid item xs={12} sm={4}>
          <InputMask
            name="comissao_pc"
            control={control}
            label="% de Comissão"
          />
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit(onConfirm)}
            loading={postLoading}
          >
            Salvar
          </Button>
        </Grid>
      </Grid>
    );
  };

  const AverageModal = ({ type }) => {
    const { postLoading } = useContext(DocumentosContext);
    const { control, handleSubmit, watch, setValue } = useForm({
      defaultValues: { type: type || null, percentual: '', valor: '' },
    });

    useEffect(() => {
      if (Boolean(watch('percentual'))) {
        const valor = (documento?.Totais?.preco * watch('percentual')) / 100;
        setValue('valor', valor);
      }
    }, [watch('percentual')]);

    const onConfirm = ({ type, valor }) => {
      const isMargem =
        type === 'internacionalizacao' ||
        type === 'fretend' ||
        type === 'segurond' ||
        type === 'impfednd' ||
        type === 'comissaond';
      if (!Boolean(type)) {
        return toastWarning('Selecione o tipo');
      }

      let valor_lancado = 0;
      const Itens = documento?.DocumentoItems?.map((i, idx) => {
        const precotot = i?.preco * i?.quantidade;
        const total = summarizer(
          documento?.DocumentoItems?.map((d) => ({
            total: d?.preco * d?.quantidade,
          })),
          'total'
        );
        const average = round((valor * precotot) / total);
        const value = round(
          idx + 1 === documento?.DocumentoItems?.length
            ? round(valor - valor_lancado)
            : average
        );

        valor_lancado = round(valor_lancado + average);
        if (isMargem) {
          return {
            id: i?.id,
            documento_id: i?.documento_id,
            Margem: {
              documento_item_id: i?.DocumentoItemMc?.documento_item_id,
              [type]: type === 'desconto_vlr' ? -value : value,
            },
          };
        } else {
          return {
            id: i?.id,
            documento_id: i?.documento_id,
            [type]: type === 'desconto_vlr' ? -value : value,
          };
        }
      });
      onSubmit({ Itens });
    };

    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6" component="div" align="center">
            Informações Gerais
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            name="type"
            control={control}
            label="Tipo de Divisão"
            options={dropTipoRateio}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <InputMask name="percentual" control={control} label="Percentual" />
        </Grid>
        <Grid item xs={12} sm={4}>
          <InputMask name="valor" control={control} label="Valor" />
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Button
            color="primary"
            variant="outlined"
            loading={postLoading}
            onClick={handleSubmit(onConfirm)}
          >
            Salvar
          </Button>
        </Grid>
      </Grid>
    );
  };

  const InfoTributoModal = ({ itens = [] }) => {
    const defaultValues = { tributo_id: null, situacao_tributaria_id: null };
    const { control, watch } = useForm({ defaultValues });
    const { postLoading } = useContext(DocumentosContext);
    const gridRef = useRef(null);
    const [gridHeight, setGridHeight] = useState(300);
    const [rows, setRows] = useState([]);
    const tributo_id = watch('tributo_id');
    const situacao_tributaria_id = watch('situacao_tributaria_id');

    useLayoutEffect(() => {
      const calculateGridHeight = () => {
        if (!gridRef.current) return;

        const { top } = gridRef.current.getBoundingClientRect();

        const footerSpace = 80;

        const height = window.innerHeight - top - footerSpace;

        setGridHeight(Math.max(200, height));
      };

      calculateGridHeight();

      window.addEventListener('resize', calculateGridHeight);

      return () => {
        window.removeEventListener('resize', calculateGridHeight);
      };
    }, []);

    const loadGrid = () => {
      setRows(
        itens?.map((item) => {
          const imposto = item?.DocumentoItemImpostos?.find(
            (imp) => imp?.tributo_id === tributo_id
          );
          const preco = Number(item?.preco || 0);
          const quantidade = Number(item?.quantidade || 0);
          const desconto = Number(item?.desconto_vlr || 0);
          const basecalculo = Number(
            (preco * quantidade + desconto).toFixed(2)
          );
          const percentual = Number(
            Number(imposto?.percentual || 0).toFixed(2)
          );

          const valor = Number(((basecalculo * percentual) / 100).toFixed(2));

          return {
            item_id: item?.id,
            documento_id: item?.documento_id,
            sequencia: item?.sequencia,
            produto_id: item?.produto_id,
            descricao: item?.descricao,
            referencia: item?.referencia,
            imposto_id: imposto?.id || null,
            basecalculo,
            percentual,
            valor,
            tributo_id: imposto?.tributo_id ?? tributo_id,
            situacao_tributaria_id:
              imposto?.situacao_tributaria_id ?? situacao_tributaria_id,
          };
        }) || []
      );
    };

    const onCellEditCommit = (e) => {
      setRows((currentRows) =>
        currentRows.map((row) => {
          if (row?.item_id !== e?.id) {
            return row;
          }

          const value =
            e?.field === 'percentual'
              ? Number(Number(e?.value || 0).toFixed(2))
              : e?.value;

          const updatedRow = { ...row, [e?.field]: value };

          const basecalculo = Number(
            Number(updatedRow?.basecalculo || 0).toFixed(2)
          );

          const percentual = Number(
            Number(updatedRow?.percentual || 0).toFixed(2)
          );

          const valor = Number(((basecalculo * percentual) / 100).toFixed(2));

          return {
            ...updatedRow,
            basecalculo,
            percentual,
            valor,
          };
        })
      );
    };

    const handleDeleteRow = useCallback((item_id) => {
      setRows((currentRows) =>
        currentRows.filter((row) => row?.item_id !== item_id)
      );
    }, []);

    const handleSubmitImpostos = () => {
      const json = {
        Itens: rows?.map((r) => ({
          id: r?.item_id,
          documento_id: r?.documento_id,
          Impostos: [
            {
              id: r?.imposto_id,
              tributo_id: r?.tributo_id,
              situacao_tributaria_id: r?.situacao_tributaria_id,
              basecalculo: r?.basecalculo,
              percentual: r?.percentual,
              valor: r?.valor,
            },
          ],
        })),
      };

      onSubmit(json);
    };

    const columns = useMemo(
      () => [
        {
          field: 'sequencia',
          headerName: 'Sequencia',
          width: 110,
          sortable: false,
        },
        {
          field: 'produto_id',
          headerName: 'Código do Produto',
          width: 150,
          sortable: false,
        },
        {
          field: 'descricao',
          headerName: 'Descrição',
          flex: 1,
          minWidth: 400,
          sortable: false,
        },
        {
          field: 'referencia',
          headerName: 'Referência',
          width: 150,
          sortable: false,
        },
        {
          field: 'situacao_tributaria_id',
          headerName: 'Situação Tributária',
          width: 300,
          sortable: false,
          valueFormatter: ({ value }) => {
            const st = findOnArray(value, drops?.SituacaoTributaria);

            return `${st?.Código} - ${st?.label}`;
          },
        },
        {
          field: 'basecalculo',
          headerName: 'Base de Cálculo',
          width: 150,
          type: 'number',
          sortable: false,
          valueFormatter: ({ value }) => currency(value * 1),
        },
        {
          field: 'percentual',
          headerName: 'Alíquota',
          width: 150,
          type: 'number',
          editable: true,
          sortable: false,
          valueFormatter: ({ value }) => `${value ?? 0} %`,
        },
        {
          field: 'valor',
          headerName: 'Valor',
          width: 150,
          type: 'number',
          sortable: false,
          valueFormatter: ({ value }) => currency(value * 1),
        },
        {
          field: 'actions',
          type: 'actions',
          headerName: 'Ações',
          width: 100,
          sortable: false,
          getActions: ({ row }) => [
            <GridActionsCellItem
              icon={<Delete />}
              label="Excluir"
              onClick={() => handleDeleteRow(row?.item_id)}
            />,
          ],
        },
      ],
      [handleDeleteRow, drops?.SituacaoTributaria]
    );

    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Alert severity="info">
            Selecione o tributo e a situação tributária que deseja aplicar aos
            itens. Em seguida, clique em <strong>Carregar</strong> para
            visualizar e editar os itens.
          </Alert>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Dropdown
            label="Tributo"
            name="tributo_id"
            control={control}
            options={drops?.Tributo}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Dropdown
            control={control}
            label="Situação Tributária"
            name="situacao_tributaria_id"
            options={drops?.SituacaoTributaria}
          />
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Button
            color="primary"
            variant="outlined"
            onClick={loadGrid}
            disabled={!tributo_id || !situacao_tributaria_id}
          >
            Carregar
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Box
            ref={gridRef}
            sx={{
              height: `${gridHeight}px`,
              width: '100%',
            }}
          >
            <DataGrid
              rows={rows}
              columns={columns}
              density="compact"
              showCellRightBorder
              showColumnRightBorder
              disableSelectionOnClick
              localeText={localeText}
              getRowHeight={() => 'auto'}
              getRowId={(row) => row.item_id}
              onCellEditCommit={onCellEditCommit}
              slots={{
                pagination: CustomPagination,
                loadingOverlay: LinearProgress,
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Button
            color="primary"
            variant="contained"
            loading={postLoading}
            onClick={handleSubmitImpostos}
          >
            Salvar
          </Button>
        </Grid>
      </Grid>
    );
  };

  const options = [
    {
      name: 'Adicionar Item',
      icon: 'add',
      action: () => openDialog(<Modal />, 'Adicionar Item'),
    },
    {
      name: 'Editar Selecionados',
      icon: 'edit',
      action: () => {
        if (Boolean(selected?.length)) {
          openDialog(<MultiModal itens={selected} />, 'Editar Itens');
        } else {
          toastWarning('Selecione ao menos um item');
        }
      },
    },
    {
      name: 'Recarregar Tributos',
      icon: 'refresh',
      action: () => {
        if (Boolean(selected?.length)) {
          onSubmitImposto(selected.map((s) => s?.id));
        } else {
          toastWarning('Selecione ao menos um item');
        }
      },
    },
    {
      name: 'Informar Tributos',
      icon: 'info',
      show: (documento?.especie_id === 4),
      action: () =>
        openDialog(
          <InfoTributoModal
            itens={selected?.length > 0 ? selected : documento?.DocumentoItems}
          />,
          'Informar Tributos'
        ),
    },
    {
      name: 'Recarregar CFOP',
      icon: 'refresh',
      action: () => {
        if (Boolean(selected?.length)) {
          onSubmitCfo(selected.map((s) => s?.id));
        } else {
          toastWarning('Selecione ao menos um item');
        }
      },
    },
    {
      name: 'Outros Valores',
      icon: 'splitscreen',
      show: Boolean(documento?.DocumentoItems?.length),
      action: () => {
        if (Boolean(documento?.DocumentoItems?.length)) {
          openDialog(<AverageModal />, 'Outros Valores');
        } else {
          toastWarning('Documento não possui item');
        }
      },
    },
    {
      name: 'Formação de Preço',
      icon: 'price_change',
      show: Boolean(documento?.Especie?.natureza === 'FATURA'),
      action: () =>
        navigate(`/app/Documento/FormacaoDePreco`, {
          state: { id: documento?.id },
        }),
    },
  ];

  const Line = ({ value, label, type }) => (
    <Grid item xs={12} sm={6}>
      <Box display="flex" alignItems="center">
        {Boolean(type) ? (
          <Typography
            sx={disableActions ? styles?.lineLabel : styles?.lineLabelLink}
            variant="subtitle2"
            onClick={() =>
              !disableActions &&
              openDialog(<AverageModal type={type} />, 'Outros Valores')
            }
          >
            {label}:
          </Typography>
        ) : (
          <Typography sx={styles?.lineLabel} variant="subtitle2">
            {label}:
          </Typography>
        )}
        <Typography sx={styles?.lineValue} variant="body2">
          {value}
        </Typography>
      </Box>
    </Grid>
  );

  const getItemDetails = (item) => {
    const origem = {
      value: Boolean(item?.DocumentoItemOrigems?.length)
        ? item?.DocumentoItemOrigems[0]?.documento_origem || 'Nº não informado'
        : null,
      hint: item?.DocumentoItemOrigems?.[0]?.especie_origem,
    };
    const vinculo = {
      value: Boolean(item?.Vinculados?.length)
        ? item?.Vinculados[0]?.documento_vinculado || 'Nº não informado'
        : null,
      hint: item?.Vinculados?.[0]?.especie_vinculado,
    };
    const isVinculo = documento?.NaturezaOperacao?.vinculo === 'SIM';
    let qtgerada = 0;

    (Boolean(isVinculo)
      ? item?.Vinculados || []
      : item?.DocumentoItemOrigems || []
    )?.forEach((m) => {
      qtgerada += m?.quantidade || 0;
    });

    return {
      origem,
      vinculo,
      isVinculo,
      quantidade: (item?.quantidade || 0) - (qtgerada || 0),
    };
  };

  const HintCell = ({ value }) => {
    if (!value?.hint) {
      return value?.value || '';
    }

    return (
      <Tooltip placement="left" title={value?.hint}>
        <Typography variant="body2">{value?.value}</Typography>
      </Tooltip>
    );
  };

  const currency = (value, options = {}) =>
    value?.toLocaleString('pt-br', {
      style: 'currency',
      currency: 'BRL',
      ...options,
    });

  const handleSelectionChange = (ids = []) => {
    if (!ids?.length) {
      setSelected([]);
      return;
    }

    const currentIds = selected?.map((item) => item?.id);
    const addedIds = ids?.filter((id) => !currentIds?.includes(id));

    if (!addedIds?.length) {
      setSelected(
        selected?.filter((item) => ids?.some((id) => id === item?.id))
      );
      return;
    }

    const addedItems = documento?.DocumentoItems?.filter((item) =>
      addedIds?.some((id) => id === item?.id)
    );
    const kitIds = addedItems?.map((item) => item?.kit_id)?.filter(Boolean);
    const nextSelected = [
      ...selected?.filter((item) => !kitIds?.includes(item?.kit_id)),
      ...addedItems?.filter((item) => !item?.kit_id),
      ...documento?.DocumentoItems?.filter((item) =>
        kitIds?.includes(item?.kit_id)
      ),
    ];

    setSelected(
      nextSelected?.filter(
        (item, index, self) =>
          index === self?.findIndex((current) => current?.id === item?.id)
      )
    );
  };

  const itemColumns = useMemo(() => {
    const getActionCount = (row = {}) => {
      const { quantidade } = getItemDetails(row);
      let count = 1;

      if (!disableActions) {
        count += 2;
      }

      if (!disableActions && Boolean(quantidade > 0)) {
        count += 1;
      }

      return count;
    };
    const getActionsColumnWidth = (count) =>
      count * 30 + Math.max(count - 1, 0) * 8 + 24;
    const actionsColumnWidth = getActionsColumnWidth(
      Math.max(
        ...(documento?.DocumentoItems || [{}])?.map((row) =>
          getActionCount(row)
        )
      )
    );
    const columns = [
      {
        field: 'actions',
        type: 'actions',
        headerName: 'Ações',
        align: 'left',
        headerAlign: 'center',
        width: actionsColumnWidth,
        minWidth: actionsColumnWidth,
        maxWidth: actionsColumnWidth,
        getActions: ({ row }) => {
          const { isVinculo, quantidade } = getItemDetails(row);
          const actions = [];

          if (!disableActions) {
            actions.push(
              <GridActionsCellItem
                icon={<Edit />}
                label="Editar"
                onClick={() => openDialog(<Modal item={row} />, 'Editar Item')}
              />,
              <GridActionsCellItem
                icon={<Delete />}
                label="Excluir"
                onClick={() => onDelete({ rotina, id: row?.id })}
              />
            );
          }

          actions.push(
            <GridActionsCellItem
              icon={<Visibility />}
              label="Detalhes"
              onClick={() =>
                navigate(`/app/Documento/Item`, {
                  state: { item: row, disableActions },
                })
              }
            />
          );

          if (!disableActions && Boolean(quantidade > 0)) {
            actions.push(
              <GridActionsCellItem
                icon={<Link />}
                label="Vínculo"
                onClick={() => {
                  const params = {
                    id: row?.id,
                    descricao: row?.descricao,
                    um: row?.UnidadeMedida?.sigla,
                    documento_id: documento?.id,
                    cadastro_id: documento?.cadastro_id,
                    filial_id: documento?.filial_id,
                    vinculo: isVinculo,
                    quantidade,
                  };
                  navigate(`/app/Documento/Vinculo/${encryptURL(params)}`);
                }}
              />
            );
          }

          return actions;
        },
      },
      { field: 'sequencia', headerName: 'Sequencia', width: 110 },
      { field: 'produto_id', headerName: 'Código do Produto', width: 150 },
      {
        field: 'descricao',
        headerName: 'Produto',
        minWidth: 400,
        flex: 1,
        renderCell: ({ row }) => (
          <Typography
            variant="body2"
            onClick={() =>
              openDrawer(<ProdutoModal item={row} />, row?.descricao)
            }
            sx={{
              textDecoration: 'underline',
              cursor: 'pointer',
              whiteSpace: 'normal',
            }}
          >
            {row?.descricao}
          </Typography>
        ),
      },
      {
        field: 'produto_referencia',
        headerName: 'Referência',
        width: 150,
        valueGetter: ({ row }) => row?.Produto?.referencia,
      },
      {
        field: 'referencia',
        headerName: 'Referência do Fornecedor',
        width: 210,
      },
      ...(!disableActions
        ? [{ field: 'saldo', headerName: 'Saldo', width: 110 }]
        : []),
      {
        field: 'quantidade',
        headerName: 'Quantidade',
        width: 140,
        valueGetter: ({ row }) =>
          `${row?.quantidade || 0} ${row?.UnidadeMedida?.sigla || ''}`,
      },
      {
        field: 'preco',
        headerName: 'Preço',
        width: 150,
        valueGetter: ({ value }) => currency(value * 1),
      },
      {
        field: 'desconto_vlr',
        headerName: 'Desconto',
        width: 140,
        valueGetter: ({ value }) => currency(value || 0),
      },
      {
        field: 'valor_total',
        headerName: 'Valor Total',
        width: 150,
        valueGetter: ({ row }) =>
          currency(row?.preco * row?.quantidade + row?.desconto_vlr),
      },
      {
        field: 'origem',
        headerName: 'Origem',
        width: 160,
        valueGetter: ({ row }) => getItemDetails(row).origem,
        renderCell: ({ value }) => <HintCell value={value} />,
      },
      ...(documento?.NaturezaOperacao?.vinculo === 'SIM'
        ? [
            {
              field: 'vinculo',
              headerName: 'Vínculo',
              align: 'center',
              headerAlign: 'center',
              width: 160,
              valueGetter: ({ row }) => getItemDetails(row).vinculo,
              renderCell: ({ value }) => <HintCell value={value} />,
            },
          ]
        : [])
    ];

    return columns;
  }, [disableActions, documento, selected]);

  return (
    <>
      <Card title="Itens" style={styles?.card}>
        <Grid container spacing={2}>
          {!disableActions && (
            <Grid item xs={12} textAlign="center">
              <ButtonMenu
                buttonProps={{ variant: 'outlined' }}
                options={options}
              />
            </Grid>
          )}
          <Grid item xs={12}>
            <DataGrid
              rows={documento?.DocumentoItems || []}
              columns={itemColumns}
              checkboxSelection
              autoHeight
              density="compact"
              disableSelectionOnClick
              showCellRightBorder
              showColumnRightBorder
              getRowHeight={() => 'auto'}
              selectionModel={selected?.map((item) => item?.id)}
              onSelectionModelChange={handleSelectionChange}
              localeText={localeText}
              components={{
                ColumnMenu: DataGridColumnMenu,
                Pagination: CustomPagination,
                LoadingOverlay: LinearProgress,
              }}
            />
          </Grid>
        </Grid>
      </Card>
      <Card title="Totais" style={styles?.card}>
        <Grid container spacing={2}>
          <Line value={documento?.Totais?.peso || 0} label="Peso" />
          <Line value={documento?.Totais?.volume || 0} label="Volume" />
          <Line
            value={(documento?.Totais?.preco || 0)?.toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
            label="Preço"
          />
          <Line
            value={(documento?.Totais?.frete || 0)?.toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
            label="Frete"
            type="frete"
          />
          <Line
            value={(documento?.Totais?.desconto || 0)?.toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
            label="Desconto"
            type="desconto_vlr"
          />
          <Line
            value={(documento?.Totais?.seguro || 0)?.toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
            label="Seguro"
            type="seguro"
          />
          <Line
            value={(documento?.Totais?.despac || 0)?.toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
            label="Despesas Acessórias"
            type="despac"
          />
          <Line
            value={(documento?.Totais?.outros || 0)?.toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
            label="Outros"
            type="outros"
          />
          <Line
            value={(documento?.Totais?.eventuais || 0)?.toLocaleString(
              'pt-br',
              {
                style: 'currency',
                currency: 'BRL',
              }
            )}
            label="Eventuais"
            type="eventuais"
          />
          <Line
            value={(documento?.Totais?.impostos || 0)?.toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
            label="Impostos"
          />
          <Grid item xs={12}>
            <Typography variant="h6" align="center">
              Total:{' '}
              {(documento?.Totais?.documento || 0)?.toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL',
              })}
            </Typography>
          </Grid>
        </Grid>
      </Card>
    </>
  );
};

export default Itens;
